import { render } from "./RuiDone.vue?vue&type=template&id=32de3864"
const script = {}
script.render = render

export default script